import { createQueryData } from '../helpers/createQueryData';

const { useQuery } = createQueryData({
  endPoint: 'Acceptance/get_regions',
  options: { errorMessage: 'Не удалось получить список районов' },
});

export const useRegionsQuery = ({
  params: { serviceCompanyId, cityId } = {},
  options,
} = {}) =>
  useQuery({
    params: { serviceCompanyId, cityId },
    options: { enabled: Boolean(serviceCompanyId), ...options },
  });
